import _uniqueId from 'lodash/uniqueId'
import PropTypes from 'prop-types'
import { useState } from 'react'

import inputStyles from './Input.module.scss'

const Input = props => {
  const [id] = useState(_uniqueId('inputId-'))

  const {
    label,
    isFullWidth,
    width,
    handleChange,
    isRequired = false,
    forwardedRef,
    ...cleanProps
  } = props

  return (
    <div
      className={
        isFullWidth ? inputStyles.inputContainerFull : inputStyles.inputContainer
      }
      style={width && { width }}
    >
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        onChange={handleChange}
        required={isRequired}
        {...cleanProps}
        ref={forwardedRef}
      />
    </div>
  )
}

Input.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isFullWidth: PropTypes.bool,
  width: PropTypes.number,
  handleChange: PropTypes.func
}

export default Input
